module.exports = __webpack_public_path__ + "img/edge_patrimoine_legende.2af5b9dd.svg";